// reducers.js
import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  RESET_USER_DETAILS,
} from '../ProfileUpdate/profileUpdateTypes';

const initialState = {
  userProfile: { data: null },
  loading: false,
  success: false,
  error: null,
  message: '',
};

const profileUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userProfile: { data: action.payload || {} },
      };
    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_USER_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case UPDATE_USER_SUCCESS:
       return {
        ...state,
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case RESET_USER_DETAILS:
      return {
        ...state,
        userProfile: { data: null },
        loading: false,
        success: false,
        error: null,
        message: '',
      };

    default:
      return state;
  }
};

export default profileUpdateReducer;
